import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import type { ID } from 'src/lib/collection';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendContinuousOptimizationCampaign,
  BackendMutationUpdateContinuousOptimizationCampaignArgs,
} from 'src/types/backend';

import { FRAGMENT_CO_CAMPAIGN } from './schema';

const MUTATION = gql`
  mutation UpdateCOCampaign(
    $id: ID!
    $trafficRate: Int
    $ctaType: String
    $conversionGoalId: ID
    $cssCtaIdList: [ID!]
  ) {
    updateContinuousOptimizationCampaign(
      id: $id
      trafficRate: $trafficRate
      ctaType: $ctaType
      conversionGoalLinkCallToActionId: $conversionGoalId
      cssCtaIdList: $cssCtaIdList
    ) {
      ...ContinuousOptimizationCampaign
    }
  }
  ${FRAGMENT_CO_CAMPAIGN}
`;

type Variables = Omit<
  BackendMutationUpdateContinuousOptimizationCampaignArgs,
  'conversionGoalLinkCallToActionId'
> & {
  conversionGoalId?: ID;
};

type Result = BackendContinuousOptimizationCampaign;

export const updateCOCampaign = async (variables: Variables) => {
  const result = await executeGqlMutation({
    mutation: MUTATION,
    variables,
  });

  return getSingleProp<Result>(result.data);
};
